import React, { FC } from 'react';
import styled from 'styled-components/native';
import { H7Regular } from '../Typography';

export const BadgeText = styled(H7Regular)`
	font-size: 10px;
	font-weight: 500;
	color: ${({ theme }) => theme.colors.surface};
`;
